import { useGetProductsQuery } from '@viome/viome-base/src/usecase/Nutrition/NutritionQuery';

export const useNutritionViewModal = () => {
  const {
    data: foodFormulaData,
    isLoading: isFoodFormulaLoading,
    isError: isErrorInFormula,
  } = useGetProductsQuery();

  return {
    foodFormulaData,
    isFoodFormulaLoading,
    isErrorInFormula,
  };
};
